export function workReducer (state = {work: [], loading: true, error: null}, action) {
  switch (action.type) {
    case 'LOAD_WORK_START':
      return {
        ...state,
        loading: true
      }
    case 'LOAD_WORK_SUCCESS':
      return {
        ...state,
        work: action.payload,
        loading: false
      }
    case 'LOAD_WORK_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
        work: []
      }
    default:
      return state;
  }
}

export default workReducer;



// WEBPACK FOOTER //
// ./src/reducers/work.js